module.exports = __webpack_public_path__ + "static/media/8_RoomControls_SolarShades_HL.91813bd0.png";